
export type DeleteUser401 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
